import React, { useState } from 'react';
import UsersList from './UsersList';
import Statistics from './Statistics';
import Timeline from './Timeline';
import { useTranslation } from 'react-i18next';
import { MdBarChart, MdTimeline, MdPeople } from 'react-icons/md';
import PageContainer from '../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../shared/layout/titles/PageTitle';
import PageContent from '../../../shared/layout/containers/PageContent';
import TabBar from '../../../shared/layout/tabs/TabBar';
import TabButton from '../../../shared/layout/tabs/TabButton';

const Users = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('usersList');

    return (
        <PageContainer>
            <PageHeader>
                <PageTitle icon={<MdPeople size={28} />}>{t('Users.title')}</PageTitle>
            </PageHeader>
            <TabBar>
                <TabButton
                    active={activeTab === 'statistics'}
                    onClick={() => setActiveTab('statistics')}
                    icon={<MdBarChart className="icon" />}
                >
                    {t('Users.statistics')}
                </TabButton>
                <TabButton
                    active={activeTab === 'timeline'}
                    onClick={() => setActiveTab('timeline')}
                    icon={<MdTimeline className="icon" />}
                >
                    {t('Users.timeline')}
                </TabButton>
                <TabButton
                    active={activeTab === 'usersList'}
                    onClick={() => setActiveTab('usersList')}
                    icon={<MdPeople className="icon" />}
                >
                    {t('Users.usersList')}
                </TabButton>
            </TabBar>
            <PageContent>
                {activeTab === 'statistics' && <Statistics />}
                {activeTab === 'timeline' && <Timeline />}
                {activeTab === 'usersList' && <UsersList />}
            </PageContent>
        </PageContainer>
    );
};

export default Users;
